

export const XLSXformat = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const CSVformat = '.csv';